import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface OneFrontBilConfig {
  proxyBaseUrl: string;
  embedParam: string;
  storageKey: string;
  appId: string;
}

export const oneFrontBilConfig: OneFrontBilConfig = {
  proxyBaseUrl: environment.oneFrontConfig.proxyBaseUrl,
  embedParam: environment.oneFrontConfig.embedParam,
  storageKey: environment.oneFrontConfig.storageKey,
  appId: environment.oneFrontConfig.appId,
};

export const ONE_FRONT_BIL_CONFIG = new InjectionToken<OneFrontBilConfig>('oneFrontBilConfig');
